import { ColumnDef } from "@tanstack/react-table";
import SkeletonElement from "@/components/Skeleton/SkeletonElement";

export const SkeletonLoader = <T,>({ columns, rowCount = 10 }: { columns?: ColumnDef<T>[]; rowCount?: number }) => {
  return columns ? (
    <>
      {Array.from({ length: rowCount }).map((_, rowIndex) => (
        <tr key={rowIndex} data-testid="loading-row">
          {columns.map((_, cellIndex) => {
            const width = Math.random() * 50 + 50;
            return (
              <td key={cellIndex} className="px-2 py-4" data-testid="loading-cell">
                <SkeletonElement height="h-4" width={width} />
              </td>
            );
          })}
        </tr>
      ))}
    </>
  ) : (
    <div className="flex flex-col">
      {Array.from({ length: rowCount }).map((_, rowIndex) => {
        const width = Math.random() * 50 + 50;
        return (
          <div key={rowIndex} className="p-6 flex flex-col gap-4 border-t">
            <SkeletonElement height="h-3" width={width} />
            <SkeletonElement height="h-3" width={width - 30} />
          </div>
        );
      })}
    </div>
  );
};
